import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../base.service';
import { ConfigService } from '../../config.service';



@Component({
  selector: 'app-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['./bank.component.css']
})
export class BankComponent implements OnInit {

  bankdetails: boolean = false;

  bankobj: any = {};
  bankdata: any[] = [];
  isEdit: boolean = false;
  SelectedIndex: any = "";

  selectedItem: any = {};

  constructor(public _baseService: BaseService, public _config: ConfigService) { }

  ngOnInit() {
    this.getAllBanks();
  }

  onSubmit() {

  }


  addbank() {

    let postBody: any = {
      "contact_name": this.bankobj.contact_name,
      "bank_name": this.bankobj.bank_name,
      "ifsc": this.bankobj.ifsc,
      "ac_no": this.bankobj.ac_no,
      "branch": this.bankobj.branch
    };


    if (this.isEdit) {

      postBody.isUpdateBank = true;
      postBody.id = this.selectedItem.id;

      let requestURL = this._config.baseURL + this._config.updateBank;

      let headerOption = this._baseService.commonheader();

      this._baseService.doPUT(requestURL, postBody, headerOption).subscribe((results: any) => {
         
        this.bankobj = results;
        this.getAllBanks();

        if(results.message)
        this._baseService.showSuccess(results.message);

        this.isEdit = false;
        this.bankobj = {};
        this.bankdetails = false;

      });

    }
    else {


      postBody.isAddBank = true;

      let requestURL = this._config.baseURL + this._config.getBank;
      let headerOption = this._baseService.commonheader();

      this._baseService.doPOST(requestURL, postBody, headerOption).subscribe((results: any) => {
        
        this.bankobj = results;

        this.getAllBanks();

        if(results.message)
        this._baseService.showSuccess(results.message);

        this.bankobj = {};
        this.isEdit = false;
        this.bankdetails = false;

      });


      // this.bankdata.push(this.bankobj);

    }

  }

  edit(item: any) {
    this.bankdetails = true;
    this.isEdit = true;



    this.bankobj = item;

    
    this.selectedItem = item;

  }


  delete(item: any) {
    // this.bankdata.splice(index, 1);

    let requestURL = this._config.baseURL + this._config.deleteBank;
    requestURL = requestURL.replace('{ID}', item.id);

    let headerOption = this._baseService.commonheader();

    this._baseService.doDELETE(requestURL, headerOption).subscribe((results: any) => {
      this.getAllBanks();

      if(results.message)
      this._baseService.showSuccess(results.message);

    });



  }


  getAllBanks() {

    let requestURL = this._config.baseURL + this._config.getBank;
    let headerOption = this._baseService.commonheader();

    this._baseService.doGET(requestURL, headerOption).subscribe((results: any) => {
      
      this.bankdata = results.data;
    });

  }

}
